const factory = (BillingPartner, Collection, _) => {
  class BillingPartnerCollection extends Collection {
    $url() {
      return `${this.$resource}.json`;
    }

    findNameById(id) {
      const index = _.findIndex(this.data, { id });

      if (index > -1) {
        return this.data[index].name;
      }

      return '';
    }

    findIdByName(name) {
      const billingPartner = this.data.find(partner => partner.name === name);

      return (billingPartner && billingPartner.id) || null;
    }
  }

  Object.assign(BillingPartnerCollection.prototype, {
    $id: 'singleton',
    $resource: 'partner',
    $type: BillingPartner,
    $$cacheModels: true,
  });

  return BillingPartnerCollection;
};

const moduleDeps = [require('data/model/billingPartner').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.billingPartner', moduleDeps)
  .factory('BillingPartnerCollection', factory);
